module.exports = __webpack_public_path__ + "img/error-401.98bba5b1.svg";